export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-shrink-0 w-full lg:w-[360px] h-[240px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20digital%20manga%20reading%20platform%20concept%2C%20floating%20comic%20books%20and%20smartphone%20with%20manga%20pages%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20Japanese%20manga%20aesthetic%20with%20modern%20flat%20design%2C%20clean%20composition%2C%20friendly%20community%20atmosphere%2C%20gentle%20gradient%20background&width=720&height=480&seq=about-manga-01&orientation=landscape"
                alt="关于迷妹漫画"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">关于迷妹</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                迷妹漫画诞生于2019年，由一群热爱漫画的开发者创建。我们深知漫迷们对优质漫画内容的渴望，致力于打造一个完全免费的漫画阅读平台。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                从最初的几十部作品到如今涵盖日本漫画、韩国漫画和国产漫画的全品类资源库，迷妹漫画始终坚持零门槛免费阅读的理念。我们的下拉式竖屏滚动阅读体验专为移动端优化，让用户在手机上也能获得如翻阅纸质漫画般的畅快感受。
              </p>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/70">
                  <p className="text-xl md:text-2xl font-heading font-bold text-primary-500">10万+</p>
                  <p className="text-xs text-foreground-500">漫画资源</p>
                </div>
                <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/70">
                  <p className="text-xl md:text-2xl font-heading font-bold text-accent-600">500万+</p>
                  <p className="text-xs text-foreground-500">活跃用户</p>
                </div>
                <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/70">
                  <p className="text-xl md:text-2xl font-heading font-bold text-secondary-600">每日更新</p>
                  <p className="text-xs text-foreground-500">从不间断</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}